/* eslint-disable max-lines */
/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import StyleGuide from '@taglivros/oef_componentes/build/components/styleGuide'
import InlineLoader from '../../../components/InlineLoader/InlineLoader'
import Modal from '@taglivros/oef_componentes/build/components/modal'
import CartaoCredito from '../../../components/CartaoCredito/CartaoCredito'
import moment from 'moment'

import { ReactComponent as CreditCard } from '../../../assets/icons/credit-card.svg'
import { ReactComponent as XIcon } from '../../../assets/icons/x.svg'

const DetalhesPedidoContainer = styled.div`
  .credit-card-details {
    padding: 13px;
    display: flex;
    align-items: center;
    gap: 5px;
    font-size: 14px;
     span {
      cursor: pointer;
      color: ${( { color } ) => color};
      text-decoration: underline;
    }
    svg path {
      cursor: pointer;
      stroke: ${( { color } ) => color};
    }
  }
`

const ModalContainer = styled.div`
  .card--modal {
    padding: 15px;
    display: flex;
    justify-content: flex-start;
    line-height: 24px;
    span {
      font-weight: 500;
    }
    .estorno {
      font-weight: 600;
    }
    .title {
      color: #343a4f;
      font-weight: 600;
      font-size: 14px;
      line-height: 20px;
      text-transform: capitalize;
    }
    .subtitle {
      color: #676c84;
      font-size: 12px;
      line-height: 16px;
    }
    p {
      text-decoration-line: none;
      color: #676c84;
      font-size: 14px;
      line-height: 16px;
    }
    a {
      text-decoration: underline;
    }
    .group {
      padding-top: 10px;
    }
    .colorful {
      color: ${( { color } ) => color};
    }
    @media (max-width: ${StyleGuide.mediaQuery.mobile}) {
      height: 450px;
      overflow: overlay;
    }
    .padding-estorno {
      padding: 10px 0px;
    }
  }
  .X {
    position: absolute;
    top: 24px;
    right: 20px;
    cursor: pointer;
  }
  .content {
    width: 100%;
  }
`

const Line = styled.div`
  border: 1px solid #efefef;
  width: 100%;
  margin-top: 10px;
`

function DetalhesPedido( { detalhePedido, loadingDetalhes, color, pedido, status } ) {
  const [ modal, setModal ] = useState( false )
  const [ xmlFile, setXmlFile ] = useState()

  const geraArquivoXML = xmlTexto => {
    const blob = new Blob( [ xmlTexto ], { 'type': 'text/plain' } )
    return window.URL.createObjectURL( blob )
  }

  useEffect( () => {
    if ( detalhePedido && detalhePedido.pagamento ) {
      if (
        detalhePedido.pagamento.notaFiscal &&
        detalhePedido.pagamento.notaFiscal.XML
      ) {
        setXmlFile( geraArquivoXML( detalhePedido.pagamento.notaFiscal.XML ) )
      }

      if (
        detalhePedido.pagamento.notaFiscalOpcional &&
        detalhePedido.pagamento.notaFiscalOpcional.XML
      ) {
        geraArquivoXML( detalhePedido.pagamento.notaFiscalOpcional.XML )
      }
    }
  }, [ detalhePedido ] )

  const ajustaValor = ( valor ) => {
    return ( valor ).toFixed( 2 )
  }

  const getTextoValoresCobranca = () => {
    const valorVenda = detalhePedido.pagamento.valor.kit - detalhePedido.pagamento.valor.desconto
    const valorFrete = detalhePedido.pagamento.valor.frete - detalhePedido.pagamento.valor.descontoFrete
    return `(R$ ${ajustaValor( valorVenda )} + frete R$ ${ajustaValor( valorFrete )})`
  }

  function getColor() {
    const statusName = status
    if ( statusName === 'Pago' ) {
      return '#347A0B'
    }
    if ( statusName === 'Espera' ) {
      return '#B72133'
    }
    return '#53586F'
  }

  function renderMesTagPedido() {
    if ( detalhePedido.tituloLivro ) {
      return (
        <h3>{detalhePedido.tituloLivro}</h3>
      )
    } else {
      return (
        <h3>{detalhePedido.mesTag.replace( '/', '-' )}</h3>
      )
    }
  }

  return (
    <div>
      {loadingDetalhes ? (
        <InlineLoader
          cor={ color }
          isCenter
        />
      ) : (
        <DetalhesPedidoContainer color={ color }>
          <div className="credit-card-details">
            <CreditCard onClick={ () => setModal( true ) } />

            <span onClick={ () => setModal( true ) }>Ver mais detalhes</span>
          </div>
        </DetalhesPedidoContainer>
      )}

      {modal ?
        <ModalContainer color={ getColor }>
          <Modal
            altura="auto"
            largura="350px"
            onShowModal={ () => setModal( false ) }
            padding
            show={ modal }
          >
            <div className="content">
              <div className="group">
                {renderMesTagPedido()}

                <div>
                  <span className="subtitle">Nº pedido {detalhePedido.id}</span>
                </div>
              </div>

              <Line />

              <div className="group">
                <span className="title colorful">{`${status} - `}</span>

                <span className="colorful">
                  { moment( detalhePedido.pagamento.data ).format( 'DD/MM/YYYY' ) }
                </span>
              </div>

              { ( detalhePedido.status === 'ESTORNADO' || detalhePedido.status === 'ESTORNO_PARCIAL' ) && pedido.statusEnvio !== 'ENTREGUE' ? (
                <>
                  <div className="group">
                    <span className="title">
                      Valor R$ {pedido.valorEstornado}
                    </span>
                  </div>

                  <div className="padding-estorno">
                    <a
                      href={ `https://imt0hjnp40.execute-api.us-east-1.amazonaws.com/prd/comprovante-estorno?vendaCobrancaId=${pedido.cobrancaId}` }
                      rel="noopener noreferrer"
                      target="_blank"
                    >
                      <span className="estorno">Comprovante de estorno</span>
                    </a>
                  </div>
                </>
              ) : (
                <>
                  <div className="group">
                    <span className="title">Endereço:</span>

                    <div>
                      <span className="subtitle">
                        {`${detalhePedido.entrega.endereco.rua || ''} ${detalhePedido.entrega.endereco.numero ||
                          ''} ${detalhePedido.entrega.endereco.complemento ||
                          ''} ${detalhePedido.entrega.endereco.cidade || ''}`}
                      </span>
                    </div>
                  </div>

                  <div className="group">
                    <span className="title">Forma de pagamento</span>

                    {detalhePedido.pagamento.cartaoCredito ? (
                      <CartaoCredito
                        cartao={ detalhePedido.pagamento.cartaoCredito }
                        esconderVencimento={ true }
                        mobile
                        resumido={ true }
                      />
                    ) : (
                      <div>
                        <span className="subtitle">
                          {detalhePedido.pagamento.metodo}
                        </span>
                      </div>
                    )}

                    <div className="group">
                      <span className="title">
                        Valor R${' '}

                        { ajustaValor( detalhePedido.pagamento.valor.total ) }
                      </span>

                      <div>
                        <span className="subtitle">
                          {getTextoValoresCobranca()}
                        </span>
                      </div>
                    </div>

                    <div>
                      <span className="subtitle">
                        {detalhePedido.pagamento.metodo}
                      </span>
                    </div>
                  </div>

                  <Line />

                  <div className="group">
                    <span className="title">Baixar nota fiscal</span>

                    <div>
                      <a
                        download
                        href={ detalhePedido.pagamento.notaFiscal.urlPDF }
                      >
                        PDF
                      </a>

                      {` / `}

                      <a
                        download="nota-fiscal.xml"
                        href={ xmlFile }
                      >
                        XML
                      </a>
                    </div>
                  </div>
                </>
              )}
            </div>

            <div className="X">
              <XIcon onClick={ () => setModal( false ) } />
            </div>
          </Modal>
        </ModalContainer> : null}
    </div>
  )
}

export default DetalhesPedido
